import * as React from 'react';
import { Box, Stack, Typography, Grid } from '@mui/material';
import { settingActions, settingObj } from '../store/SettingSlice';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from "react-router-dom";
import * as JSTool from '../store/JSTool';

import TitleView from '../component/TitleView';

export default function Page4_m(props) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const settingData = useSelector(state => state.settingData);
    const [index, setIndex] = React.useState(0);
    const ary = [{
        mt: '200rem',
        name: 'Ritsu',
        headImg: 'mg_0_2.png',
        bigImg: 'mg_0_big22',
        nick: 'Lost Elves',
        info: 'Naive, spirited, and pure-hearted, she is brimming with curiosity about the world around her. Her heart is filled with a yearning for universal love, and she is averse to resolving issues through extreme measures.',
    }, {
        mt: '-100rem',
        name: 'Kuroro',
        headImg: 'mg_1_2.png',
        bigImg: 'mg_1_big2',
        nick: 'Gospel Shackles',
        info: 'She is clever and well-behaved but a bit absent-minded. She serves as the joy-bringer within the team and has the closest relationship with Lord Oracle.',
    }, {
        mt: '-50rem',
        name: 'Kurokami',
        headImg: 'mg_2_2.png',
        bigImg: 'mg_2_big2',
        nick: 'The everlasting luminosity',
        info: 'As the heir to the prestigious Upper House Kagami family, she takes great pleasure in protecting others. However, she can\'t help but feel disheartened when others criticize her as being "serious" and "stiff."',
    }, {
        mt: '-130rem',
        name: 'Angie',
        headImg: 'mg_3_2.png',
        bigImg: 'mg_3_big2',
        nick: 'Guardian of the Long Night',
        info: 'She is a serene and thoughtful scholar who keeps her emotions in check. Her incisive intuition frequently draws other novas to seek her guidance. Angie likes to make plans and has strong execution ability.',
    }, {
        mt: '100rem',
        name: 'Mia',
        headImg: 'mg_4_2.png',
        bigImg: 'mg_4_big22',
        nick: 'Silver Blast',
        info: 'Vivacious and bright, she is a good-natured soul who struggles to turn down requests. In her endeavors, she does her best to accommodate everyone\'s feelings, though she occasionally reveals a subtly mischievous side.',
    }]

    React.useEffect(() => {

    }, []);

    return (
        <Stack
            id={props.anchorId}
            sx={{
                width: 1,
                height: settingData.innerHeight,
                alignItems: 'center',
                justifyContent: 'center',
                position: 'relative',
            }}>

            <Box
                component={'img'}
                src={JSTool.getImgPath('bg/bg_4.png')}
                sx={{
                    width: 1,
                    height: settingData.innerHeight,
                    objectFit: 'cover',
                    zIndex: 1,
                    position: 'absolute',
                }} />

            <Box component={'img'}
                src={JSTool.getImgPath(`${ary[index].bigImg}.png`)}
                sx={{
                    width: 1,
                    height: 1,
                    objectFit: 'cover',
                    position: 'absolute',
                    zIndex: 1,
                    mt:ary[index].mt,
                }} />


            <TitleView title='Characters' mt={'100rem'} />

            <Box sx={{flex:1}}/>

            <LeftView item={ary[index]} />

            <Grid container spacing={1.5}
                sx={{
                    width: 0.92,
                    zIndex: 10,
                    mt: 1,
                    mb:2,
                }}>
                {ary.map((value, i) => {
                    return <Grid key={i} item xs={6}>  <HeadItem index={i} item={value} setIndex={setIndex} /> </Grid>
                })}
            </Grid>

        </Stack>
    );
}

function HeadItem(props) {

    return (
        <Stack onClick={() => { props.setIndex(props.index) }} sx={{
            cursor: 'pointer',
        }}>
            <Box component={'img'}
                src={JSTool.getImgPath(props.item.headImg)}
                sx={{
                    height: '70rem',
                    cursor: 'pointer',
                    objectFit: 'cover',
                }} />
            <Typography sx={{
                color: 'white',
                fontSize: '22rem',
                fontFamily: window.font0,
                position: 'absolute',
                ml: '33rem',
                mt: '30rem',
            }}>
                {props.item.name}
            </Typography>
        </Stack>
    );
}


function LeftView(props) {

    return (
        <Stack sx={{
            alignItems: 'center',
            zIndex: 1,
            px: 3,
            py: 1,
            width: 0.8,
            position: 'relative',
        }}>
            <Stack sx={{
                position: 'absolute',
                flexDirection: 'row',
                height: 1,
                width: 1,
                top: 0,
                left: 0,
                justifyContent: 'center',
                zIndex: 1,
            }}>

                <Box sx={{
                    width: '30rem',
                    background: 'linear-gradient(90deg, #00000000 , #000000c0)',
                }} />
                <Box sx={{
                    flex: 1,
                    background: '#000000c0',
                }} />
                <Box sx={{
                    width: '100rem',
                    background: 'linear-gradient(-90deg, #00000000 , #000000c0)',
                }} />
            </Stack>


            <Typography

                sx={{
                    zIndex: 2,
                    width: 1,
                    fontSize: '25rem',
                    color: 'white',
                    fontFamily: window.font0,
                    opacity: 0.9,
                }}>
                {props.item.name}
            </Typography>

            <Typography
                sx={{
                    zIndex: 2,
                    width: 1,
                    fontSize: '20rem',
                    color: 'white',
                    fontFamily: window.font0,
                    opacity: 0.9,
                }}>
                {props.item.nick}
            </Typography>


            {/* 自动换行 */}
            <Typography
                sx={{
                    zIndex: 2,
                    width: 1,
                    mt: 2,
                    maxWidth: 1,
                    fontSize: '14rem',
                    color: 'white',
                    fontFamily: window.font0,
                    opacity: 0.9,
                    wordBreak: 'break-word',
                    wordWrap: 'break-word',
                    overflowWrap: 'break-word',
                }}>
                {props.item.info}
            </Typography>
        </Stack>
    );
}